import type { StationTrainDefectIconType } from "@framework/types";

import bearingIcon from "../../../../../../../../assets/icons/station-defects/station-defect-bearing-gray.png";
import beltIcon from "../../../../../../../../assets/icons/station-defects/station-defect-belt-gray.png";
import couplingIcon from "../../../../../../../../assets/icons/station-defects/station-defect-coupling-gray.png";
import electricalIcon from "../../../../../../../../assets/icons/station-defects/station-defect-electrical-gray.png";
import fanIcon from "../../../../../../../../assets/icons/station-defects/station-defect-fan-gray.png";
import gearsIcon from "../../../../../../../../assets/icons/station-defects/station-defect-gears-gray.png";
import imbalanceIcon from "../../../../../../../../assets/icons/station-defects/station-defect-imbalance-gray.png";
import oilIcon from "../../../../../../../../assets/icons/station-defects/station-defect-oil-gray.png";
import otherIcon from "../../../../../../../../assets/icons/station-defects/station-defect-other-gray.png";
import temperatureIcon from "../../../../../../../../assets/icons/station-defects/station-defect-temperature-gray.png";

export const STATION_DEFECT_ICON_SRCS: Record<StationTrainDefectIconType, string> = {
  bearing: bearingIcon,
  imbalance: imbalanceIcon,
  fan: fanIcon,
  coupling: couplingIcon,
  belt: beltIcon,
  gears: gearsIcon,
  electrical: electricalIcon,
  oil: oilIcon,
  temperature: temperatureIcon,
  other: otherIcon,
};

let preloadPromise: Promise<void> | null = null;

export const preloadStationDefectIcons = (): Promise<void> => {
  if (preloadPromise) {
    return preloadPromise;
  }

  preloadPromise = Promise.all(
    Object.values(STATION_DEFECT_ICON_SRCS).map(
      src =>
        new Promise<void>(resolve => {
          const image = new Image();
          image.onload = () => resolve();
          image.onerror = () => resolve();
          image.src = src;
        }),
    ),
  ).then(() => undefined);

  return preloadPromise;
};
